import { useRef } from "react";
import { fileUrl, FALLBACK_COVER } from "@/lib/api";

// Pioneer-style jog wheel: spins while playing; dragging around it scrubs the track.
export const JogWheel = ({ cover, spinning, onScrub, size = "w-72 h-72", testid = "jog-wheel", label = "TGA" }) => {
  const ref = useRef();
  const last = useRef(null);
  const angle = (e) => { const r = ref.current.getBoundingClientRect(); return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)) * 180 / Math.PI; };
  const down = (e) => { if (!onScrub) return; e.currentTarget.setPointerCapture(e.pointerId); last.current = angle(e); };
  const move = (e) => {
    if (last.current == null) return;
    const a = angle(e);
    let d = a - last.current;
    if (d > 180) d -= 360;
    if (d < -180) d += 360;
    last.current = a;
    onScrub(d / 360 * 6);
  };
  const up = () => { last.current = null; };

  return (
    <div ref={ref} data-testid={testid} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
      className={`${size} relative rounded-full jog-ring p-[6%] touch-none ${onScrub ? "cursor-grab active:cursor-grabbing" : ""} ${spinning ? "led-ring" : ""} transition-shadow duration-500`}>
      <div className="absolute inset-[3%] rounded-full border-2 border-dashed border-emerald-400/40 pointer-events-none" style={{ opacity: spinning ? 1 : 0.35 }} />
      <div className={`relative h-full w-full rounded-full jog-platter border border-black/40 vinyl-spin ${spinning ? "" : "vinyl-paused"}`}>
        <span className="absolute left-1/2 top-[4%] -translate-x-1/2 h-[14%] w-[3px] rounded-full bg-white/90 shadow-[0_0_10px_#fff]" />
        <div className="absolute inset-[30%] rounded-full overflow-hidden border-4 border-[#0e1020] shadow-[0_0_0_2px_rgba(255,255,255,0.15)]">
          {cover ? <img src={fileUrl(cover) || FALLBACK_COVER} alt="" className="h-full w-full object-cover" draggable={false} />
            : <span className="h-full w-full grid place-items-center bg-emerald-500 font-display font-black text-[#151827]">{label}</span>}
        </div>
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[6%] w-[6%] rounded-full bg-zinc-300 border border-black/50" />
      </div>
    </div>
  );
};
